import React from 'react';
import { Breadcrumb, breadcrumbConfig } from 'components/navigation/Breadcrumb';
import { NotificationDropdown } from 'features/notifications';
import { GlobalSearchBar } from 'features/global-search/components/GlobalSearchBar';
import { useRoleCan } from 'core/hooks/useRoleCan';
import { Capability } from 'core/roles';

export const DashboardHeader: React.FC = () => {
  // Not offered under the Portail Gestion (capability matrix).
  const canSearch = useRoleCan(Capability.GlobalSearchAccess);

  return (
    <div>
      {/* Header principal */}
      <div className="flex items-center gap-6 p-4 border shadow rounded-xl bg-white">
        {/* Recherche globale (clients, contrats, devis, simulations, notes, collectifs) */}
        {canSearch ? (
          <GlobalSearchBar className="flex-1" />
        ) : (
          // Keeps the notifications pinned to the right
          <div className="flex-1" />
        )}
        <NotificationDropdown />
      </div>

      {/* Breadcrumb */}
      <div className="px-4 py-2">
        <Breadcrumb config={breadcrumbConfig} separator=">" className="mt-2" />
      </div>
    </div>
  );
};
